/*
    eslint-disable func-names,
    no-undef,
    import/exports-last,
    promise/avoid-new,
    unicorn/prefer-add-event-listener,
    promise/catch-or-return,
    import/no-unused-modules,
    promise/always-return,
    promise/prefer-await-to-then,
    no-unused-vars,
    consistent-return,
    no-param-reassign,
    no-magic-numbers,
    no-negated-condition
*/
import "./block-exposed-credentials.scss";
import { getLogger } from "loglevel";

// this we need to make HS script jQuery independent
(function () {
    window.jQuery =
        window.jQuery ||
        function (nodeOrSelector) {
            if (typeof nodeOrSelector === "string") {
                return document.querySelector(s);
            }

            return nodeOrSelector;
        };
})();

export function loadJs(url) {
    return new Promise((resolve, reject) => {
        const element = document.createElement("script");

        element.src = url;
        element.async = true;
        element.addEventListener("load", () => resolve(url));
        element.onerror = () => reject(url);

        document.body.append(element);
    });
}

export default class ExposedCredential {
    constructor() {
        this.selector = ".b-exposed-credentials";
        this.logger = getLogger("c-form-hubspot");
        this.logger.setLevel("info");
        this.email = "";
    }

    bootstrap() {
        const blocks = Array.from(document.querySelectorAll(this.selector));

        this.loadScripts().then(() => {
            blocks.forEach((block) => {
                const form = block.querySelector(
                    ".b-exposed-credentials__form"
                );

                this.loadForm(form);
            });
        });
    }

    loadScripts() {
        this.logger.info("loadScripts", "Loading HubSpot form scripts");

        return Promise.all([
            loadJs("https://js.hsforms.net/forms/v2-legacy.js"),
            loadJs("https://js.hsforms.net/forms/v2.js"),
        ]).catch((error) => {
            this.logger.warn(
                "bootstrap",
                "Unable to load HubSpot form scripts",
                error
            );
        });
    }

    loadForm(formElement) {
        if (!window.hbspt.forms) {
            this.logger.warn(
                "loadForm",
                "Unable to load form. HubSpot Forms API script not available."
            );

            return false;
        }

        const formData = this.getFormData(formElement);

        window.hbspt.forms.create(formData);
    }

    getFormData(formElement) {
        const formData = {
            target: `#${formElement.getAttribute("id")}`,
            formInstanceId: formElement.getAttribute("id"),
            portalId: formElement.dataset.portalId,
            formId: formElement.dataset.formId,
            onFormReady: $form => this.onFormReady(formElement),

            // redirectUrl: formEl.getAttribute('data-redirect-url'),
            onFormSubmitted: () => this.onFormSubmitted(formElement),
            onFormSubmit: (form) => this.onFormSubmit(formElement),
        };

        if (formElement.dataset.includeStyles === "false") {
            formData.css = "";
            formData.cssRequired = "";
        }

        return formData;
    }

    onFormReady(formElement) {
        this.logger.info("onFormReady", formElement);

        const {checkedByDefault} = formElement.dataset;

        if ( checkedByDefault === "true" ) {
            const legalConsentContainer = formElement.querySelector(".legal-consent-container");
            const checkboxes = legalConsentContainer.querySelectorAll('input[type="checkbox"]');

            const intervalId = setInterval(() => {
                const {unchecked} = formElement.dataset;

                if (!unchecked) {
                    Array.from(checkboxes).forEach(item => {
                        item.checked = true;
                    });
                } else {
                    clearInterval(intervalId);
                }
            }, 100);


            Array.from(checkboxes).forEach(checkbox => {
                checkbox.addEventListener("change", event => {
                    formElement.dataset.unchecked = "true";
                    clearInterval(intervalId);
                })
            });
        }
    }


    onFormSubmit(formElement) {
        this.logger.info("onFormSubmit", formElement);

        const form = formElement.querySelector(".hs-form");
        const email = form.querySelector('.hs-input[type="email"]').value;

        this.email = email;

        formElement.parentNode.parentNode.parentNode.parentNode.classList.add(
            "b-exposed-credentials--submitted"
        );
    }

    onFormSubmitted(formElement) {
        const url = `${formElement.dataset.redirectUrl}?email=${this.email}`;

        this.logger.info("onFormSubmitted", formElement, this.email, url);
        window.location.href = url;
    }
}

const block = new ExposedCredential();

block.bootstrap();
